import { FetchError } from 'utils/FetchError';

export const DETACH_UNCONFIRMED_MESSAGE =
  'Результат открепления не удалось подтвердить, обновите список и проверьте статус сотрудника.';

export interface ApiErrorItem {
  message: string;
  code?: string;
  field?: string;
}

export interface DetachErrorFeedback {
  message: string;
  fieldErrors: ApiErrorItem[];
  shouldRefreshList: boolean;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const readFieldErrors = (data: unknown): ApiErrorItem[] => {
  if (!isRecord(data) || !Array.isArray(data.errors)) {
    return [];
  }

  return data.errors.filter(
    (item): item is ApiErrorItem => isRecord(item) && typeof item.message === 'string' && item.message.length > 0
  );
};

const isResponseLike = (value: unknown): value is Response =>
  isRecord(value) && typeof value.status === 'number' && typeof value.json === 'function';

export const getErrorResponse = (error: unknown): Response | undefined => {
  if (error instanceof FetchError) {
    return error.response;
  }

  if (isRecord(error) && isResponseLike(error.res)) {
    return error.res;
  }

  return undefined;
};

export const getDetachErrorFeedback = async (response?: Response): Promise<DetachErrorFeedback> => {
  const status = response?.status;
  const shouldRefreshList = !response || status === 504 || (typeof status === 'number' && status >= 500);

  if (!response) {
    return {
      message: DETACH_UNCONFIRMED_MESSAGE,
      fieldErrors: [],
      shouldRefreshList,
    };
  }

  try {
    const data: unknown = await response.json();
    const fieldErrors = readFieldErrors(data);

    if (fieldErrors.length > 0 && !shouldRefreshList) {
      return {
        message: fieldErrors[0].message,
        fieldErrors,
        shouldRefreshList,
      };
    }
  } catch {
    // 504 and proxies often return an empty or HTML body instead of JSON
  }

  return {
    message: DETACH_UNCONFIRMED_MESSAGE,
    fieldErrors: [],
    shouldRefreshList,
  };
};
